import React from 'react';
import{ map } from 'lodash';

// local dependencies
import { withNetworkState } from 'ui/hoc/withNetworkState';
import { widgetPreloader as WidgetPreloader } from 'ui/views/generic/widgetPreloader';
import { Icon } from 'modules/icon-bank';
import { getLabel } from 'utils/getLabel';
import { WIDGET_NAMES } from 'constants/entity-names';
import { MemberDetailsPayBalanceSelectCard } from 'ui/containers/MemberDetailsPayBalanceSelectCard';
import { MemberDetailsPayBalanceSetAmount } from 'ui/containers/MemberDetailsPayBalanceSetAmount';
import { button as Button } from 'modules/button';
import { pageLevelSuccessAcknowledgement as PageLevelSuccessAcknowledgement } from 'ui/views/widgets/pageLevelSuccessAcknowledgement';

// widget views
const WIDGET_VIEWS = {
	[ WIDGET_NAMES.PAY_BALANCE_SET_AMOUNT ]: MemberDetailsPayBalanceSetAmount,
	[ WIDGET_NAMES.PAY_BALANCE_PAYMENT_OPTIONS ]: MemberDetailsPayBalanceSelectCard,
};

/*******************************/

// success view
const memberDetailsPayBalanceStepsWidgetSuccess = ( props ) => {

	// success
	if( props.displaySuccessAcknowledgement ) {
		return (
			<div className='ui-member-details-pay-balance-steps-widget'>
				<PageLevelSuccessAcknowledgement
					{ ...props.successAcknowledgementData  }
					onActionClick = { props.onSuccessfullPayment }
					type={ 'default' }
				/>
			</div>
		);
	}

    return (
        <div className='ui-member-details-pay-balance-steps-widget'>
			
			{/* back action */}
            <div className='ui-member-details-pay-balance-steps-widget__action'>
				{ map( props.navActions, ( navAction ) => {

					// get the action for navAction
					const iconId = 'back' === navAction.name ? 'backArrow' : null;

					return (
						<div
							className='ui-member-details-pay-balance-steps-widget__action__nav-action'
							key={ navAction.name }
							onClick={ () => props.onNavActionClick( navAction ) }
						>
							<Icon id={ iconId } />
							<div className='ui-member-details-pay-balance-steps-widget__action__nav-action__label'>
								{ getLabel( navAction.title ) }
							</div>
						</div>
					);
				} ) }
			</div>
			
			{/* body */}
			<div className='ui-member-details-pay-balance-steps-widget__body'>

				{/* widgets */}
				<div className='ui-member-details-pay-balance-steps-widget__body__widgets'>
					{
						map( props.widgets, ( widget ) => {

							// widget view
							const WidgetView = WIDGET_VIEWS[ widget.name ];

							return (
								<div key={ widget.name } className='ui-member-details-pay-balance-steps-widget__body__widgets__widget'>
									<div className='ui-member-details-pay-balance-steps-widget__body__widgets__widget__title'>
										{
											widget.name === WIDGET_NAMES.PAY_BALANCE_PAYMENT_OPTIONS ? (
												<div className='ui-member-details-pay-balance-steps-widget__body__widgets__widget__title__icon'>
													<Icon id='paymentCard' />
												</div>
											) : null
										}
										
										<div className='ui-member-details-pay-balance-steps-widget__body__widgets__widget__title__text'>
											{ getLabel( widget.title ) }
										</div>
									</div>

									<div className='ui-member-details-pay-balance-steps-widget__body__widgets__widget__view'>
										<WidgetView
											widget={ widget }
											onAmountChange={ props.onAmountChange }
											onPaymentOptionSelect={ props.onPaymentOptionSelect }
											requestPayload={ props.requestPayload }
											paymentSelectionId={ props.paymentSelectionId }
										/>
									</div>
								</div>
							);
						} )
					}
				</div>

				{/* actions */}
				<div className='ui-member-details-pay-balance-steps-widget__body__actions'>
					{
						map( props.actions, ( action ) => {
							return (
								<Button
									key={ action.name }
									className='ui-member-details-pay-balance-steps-widget__body__actions__action'
									size='large'
									title={ action.title }
									onClick={ () => props.onNavActionClick( action ) }
									outline={ 'cancel' === action.name }
									disabled={ 'payNow' === action.name && props.disableSubmitAction }
								/>
							);
						} )
					}
				</div>
			</div>

        </div>
    );
};

// set display name
memberDetailsPayBalanceStepsWidgetSuccess.displayName = 'memberDetailsPayBalanceStepsWidgetSuccess';

// set default props
memberDetailsPayBalanceStepsWidgetSuccess.defaultProps = {};

// prop types
memberDetailsPayBalanceStepsWidgetSuccess.propTypes = {};

/*******************************/

// preloader widget view
const memberDetailsPayBalanceStepsWidgetPreloader = () => {
    return (
        <div className='ui-member-details-pay-balance-steps-widget-preloader'>
            <WidgetPreloader />
        </div>
    );
};

// set display name
memberDetailsPayBalanceStepsWidgetPreloader.displayName = 'memberDetailsPayBalanceStepsWidgetPreloader';

// set default props
memberDetailsPayBalanceStepsWidgetPreloader.defaultProps = {};

// prop types
memberDetailsPayBalanceStepsWidgetPreloader.propTypes = {};

/*******************************/

/**
 * @desc react view
 * @example
 * import { memberDetailsPayBalanceStepsWidget as MemberDetailsPayBalanceStepsWidgetView } from 'ui/views/widgets/memberDetailsPayBalanceStepsWidget';
 */
export const memberDetailsPayBalanceStepsWidget = withNetworkState( memberDetailsPayBalanceStepsWidgetPreloader, memberDetailsPayBalanceStepsWidgetSuccess );
